import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NEW_WINDOW_PROPS } from 'data/global';
import LinkToIcon from 'icons/LinkTo.icon';
import { Link } from 'react-router-dom';
import { getDataRoomRoute } from 'utils';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

import './ManageFaqText.styles.scss';

type ManageFaqTextProps = {
  className?: string;
};

const ManageFaqText: React.FC<ManageFaqTextProps> = (props) => {
  const { className } = props;

  const classes = classNames('manage-faq-text', className);

  const { t } = useTranslation();

  const {
    dataRoom: { _id: dataRoomId },
  } = useContext(DataRoomContext);

  return (
    <div className={classes}>
      <div>
        <p>{t('manageFaqHeading')}</p>
        <Link
          to={getDataRoomRoute(
            dataRoomId,
            'questions/frequently-asked-questions',
          )}
          {...NEW_WINDOW_PROPS}
        >
          <LinkToIcon />
          {t('viewFaqs')}
        </Link>
      </div>
      <p>{t('manageFaqDescription')}</p>
    </div>
  );
};

export default ManageFaqText;
